module.exports = __webpack_public_path__ + "img/36_34.b5cda00f.png";